import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { saveEntity } from '../entity/api_entity';

export function saveContact(app, dataToSave) {
  return saveEntity(app, dataToSave);
}

export function fetchContactDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity/contact/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function deleteContact(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ENTITY
  });
}

export async function fetchContactForEdit(app, params,) {
  const { id, path } = params;
  const docType = DocType.ENTITY;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });

  return util.filterCustomFieldsByViewMode(doc, path);
}
